import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import DashboardPage from "./pages/Dashboard/page";
import MarketingPage from "./pages/Marketing/page";
import ContactsPage from "./pages/Contacts/page";
import Arive from "./pages/Marketing/arive";
import WhitelistManagementPage from "./pages/Settings/page";
import UserPermissionsPage from "./pages/UserPermissions/page";
import LoaPermissionsPage from "./pages/LoaPermissions/page";
import DemoLinksPage from "./pages/DemoLinks/page";
import AnnouncementsPage from "./pages/Announcements/page";
import ProcessingMonitoringPage from "./pages/ProcessingMonitoring/page";
// import SettingsPage from "./pages/Settings/page";
import React, { useState, useEffect } from "react";
import {
  getAuth,
  signInWithCustomToken,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { apiUrlDev, apiUrlLocal, apiUrlProdFirebase } from "./globalVariables";
import { initializeApp } from "firebase/app";
import { authDev, authProd } from "./firebase";
import NotificationsPage from "./pages/Notifications/page";
import QueuePage from "./pages/Queue/page";
import FeedbackPage from "./pages/Feedback/page";
import PromptsPage from "./pages/Prompts/page";
import QASprintAnalyticsPage from "./pages/QASprintAnalytics/page";
import GlobalSearchPage from "./pages/GlobalSearch/page";
import OrganizationLoanSearchPage from "./pages/OrganizationLoanSearch/page";
import PCWatchdogPage from "./pages/PCWatchdog/page";
import CustomInstructionsPage from "./pages/CustomInstructions/page";
import LeadConversionPage from "./pages/LeadConversion/page";
import EnterpriseOrgsPage from "./pages/EnterpriseOrgs/page";
import OrgUsersReportPage from "./pages/OrgUsersReport/page";
import SignupsPage from "./pages/Signups/page";
import AskAddyChatsPage from "./pages/AskAddyChats/page";
import DevToolsPage from "./pages/DevTools/page";
import ProdDeploymentPage from "./pages/ProdDeployment/page";
import RoadmapPage from "./pages/Roadmap/page";
import EvalsPage from "./pages/Evals/page";
import LangfuseAnalyticsPage from "./pages/LangfuseAnalytics/page";
import OrganizationLimitsPage from "./pages/OrganizationLimits/page";
import GcpMonitoringPage from "./pages/GcpMonitoring/page";
import CostOverviewPage from "./pages/CostOverview/page";
import PcPerformancePage from "./pages/PcPerformance/page";
import ChangelogsPage from "./pages/Changelogs/page";
import HomeCatalogPage from "./pages/Home/page";
import LoanStageAnalyticsPage from "./pages/LoanStageAnalytics/page";
import SupportInsightsPage from "./pages/SupportInsights/page";
import OrgUsageIndexPage from "./pages/OrgUsageAnalytics/OrgUsageIndexPage";
import OrgUsageDetailPage from "./pages/OrgUsageAnalytics/OrgUsageDetailPage";
import UserUsageProfilePage from "./pages/OrgUsageAnalytics/UserUsageProfilePage";
import EnterpriseBillingUsagePage, {
  EnterpriseBillingUsageDetailPage,
} from "./pages/EnterpriseBillingUsage/page";
import OrgOverviewPage from "./pages/OrgOverview/page";
import NotionBriefingsPage from "./pages/NotionBriefings/page";
import IntegrationsPage from "./pages/Integrations/page";
import IncomeCalculationRunsPage from "./pages/IncomeCalculationRuns/page";
import IncomeCalculationRunDetailPage from "./pages/IncomeCalculationRuns/DetailPage";
import NewfiSplitEdocsPage from "./pages/NewfiSplitEdocs/page";
import NewfiSplitEdocDetailPage from "./pages/NewfiSplitEdocs/DetailPage";
import ProjectViewsPage from "./pages/ProjectViews/page";
import ProjectViewPage from "./pages/ProjectViews/ViewPage";
import ReferralEligibilityPage from "./pages/ReferralEligibility/page";
import ModelSwitchEvalPage from "./pages/ModelSwitchEval/page";
import ClientTrackingPage from "./pages/ClientTracking/page";
import PilotsPage from "./pages/Pilots/page";
import VoiceConsolePage from "./pages/VoiceConsole/page";
import DemoInvitesPage from "./pages/DemoInvites/page";
import DemoAccessPage from "./pages/DemoAccess/page";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCDBO1NWURhFlBZpd1Bxc2pxUPhV8k8LMQ",
  authDomain: "hey-addy-chatgpt.firebaseapp.com",
  databaseURL: "https://hey-addy-chatgpt-default-rtdb.firebaseio.com",
  projectId: "hey-addy-chatgpt",
  storageBucket: "hey-addy-chatgpt.appspot.com",
  messagingSenderId: "284266859441",
  appId: "1:284266859441:web:68d1fc5acb5e9ffa410b90",
  measurementId: "G-J966MHS7YM",
};
initializeApp(firebaseConfig);
// const app = initializeApp(firebaseConfig);
// getAnalytics(app);

// Cookie utility functions
const AUTH_COOKIE_NAME = "addy_admin_auth";
const AUTH_COOKIE_EXPIRY_DAYS = 1;

const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Strict`;
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
};

// Check if auth cookie exists and is valid
const isAuthCookieValid = () => {
  const authData = getCookie(AUTH_COOKIE_NAME);
  if (!authData) return false;
  
  try {
    const parsed = JSON.parse(authData);
    const now = Date.now();
    // Check if cookie has expired (shouldn't happen due to browser handling, but extra safety)
    if (parsed.expiresAt && now > parsed.expiresAt) {
      deleteCookie(AUTH_COOKIE_NAME);
      return false;
    }
    return !!parsed.authenticated;
  } catch (e) {
    deleteCookie(AUTH_COOKIE_NAME);
    return false;
  }
};

// Set auth cookie on successful login
const setAuthCookie = (userEmail) => {
  const authData = {
    authenticated: true,
    email: userEmail,
    loginTime: Date.now(),
    expiresAt: Date.now() + AUTH_COOKIE_EXPIRY_DAYS * 24 * 60 * 60 * 1000,
  };
  setCookie(AUTH_COOKIE_NAME, JSON.stringify(authData), AUTH_COOKIE_EXPIRY_DAYS);
};

// Clear auth cookie on logout
const clearAuthCookie = () => {
  deleteCookie(AUTH_COOKIE_NAME);
};

const getDevAdminBaseUrls = () => {
  if (window.location.hostname.includes("localhost")) {
    return [apiUrlLocal, apiUrlDev];
  }

  return [apiUrlDev];
};

const requestAdminToken = async (baseUrl, userId) => {
  const loginUrl = new URL(baseUrl + "/admin/login");
  const response = await fetch(loginUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ userId }),
  });
  const data = await response.json();

  if (
    !response.ok ||
    !data?.metadata?.result ||
    data.metadata.result !== "success" ||
    !data?.data?.token
  ) {
    throw new Error(data?.reason || "Admin login failed");
  }

  return data.data.token;
};

// Waits for one Firebase Auth instance to finish restoring its persisted
// session (IndexedDB). Always resolves: an instance with nothing stored still
// fires the observer once, with `null`.
const waitForRestoredUser = (authInstance) =>
  new Promise((resolve) => {
    const unsubscribe = authInstance.onAuthStateChanged(
      (user) => {
        unsubscribe();
        resolve(user);
      },
      () => {
        unsubscribe();
        resolve(null);
      },
    );
  });

// Dev auth is best-effort and only a few pages read it, so it is synced in the
// background rather than blocking the UI. Kept module-level so overlapping
// callers share one in-flight attempt instead of racing duplicate logins.
let devAuthSyncPromise = null;

const syncDevAuth = (userId) => {
  if (devAuthSyncPromise) return devAuthSyncPromise;

  devAuthSyncPromise = (async () => {
    let devError = null;

    for (const baseUrl of getDevAdminBaseUrls()) {
      try {
        const devToken = await requestAdminToken(baseUrl, userId);
        await signInWithCustomToken(authDev, devToken);
        return true;
      } catch (error) {
        devError = error;
      }
    }

    console.warn("Dev auth sync failed:", devError);
    return false;
  })().finally(() => {
    devAuthSyncPromise = null;
  });

  return devAuthSyncPromise;
};

// The admin Cloud Function runs with `minInstances: 0`, so the first request
// after an idle period pays a multi-second cold start. Nudging it awake when the
// login form mounts means that cost is paid while the user is still typing
// rather than after they hit "Log in". Fire-and-forget: the response is the
// unauthenticated health check and is never read.
const prewarmAdminApi = () => {
  fetch(apiUrlProdFirebase + "/", { method: "GET" }).catch(() => {});
};

// Called once, at login. `defaultAuth` is deliberately not re-signed with the
// custom token: it points at the same Firebase project as `authProd` and the
// email/password sign-in that just ran already established that session, so a
// second sign-in would only add a round trip. The prod `/admin/login` call is
// still awaited because it doubles as the authorization gate — it fails for a
// uid that is not in `authorizedAdminIDs`.
const signInToProjectAuths = async (userId) => {
  // Both tokens are requested up front so the dev Cloud Function (which is
  // usually cold) warms in parallel with the prod one instead of after it.
  const devSync = syncDevAuth(userId);
  devSync.catch(() => {});

  const prodToken = await requestAdminToken(apiUrlProdFirebase, userId);
  await signInWithCustomToken(authProd, prodToken);
};

// Called on every page refresh. All three auth instances persist their own
// session, so the normal path is purely local: wait for them to rehydrate and
// render. Tokens are only re-minted for an instance that actually came back
// empty, and a missing dev session never blocks the dashboard.
const restoreProjectAuths = async () => {
  const [defaultUser, prodUser, devUser] = await Promise.all([
    waitForRestoredUser(getAuth()),
    waitForRestoredUser(authProd),
    waitForRestoredUser(authDev),
  ]);

  const user = defaultUser || prodUser;
  if (!user) return null;

  // `getAuth()` and `authProd` are two app instances over the same Firebase
  // project, so a single custom token repairs whichever came back empty.
  // Normally neither is — each restores from its own persisted session and this
  // block never runs. It is worth awaiting because pages read `currentUser` off
  // both instances as soon as they mount.
  if (!defaultUser || !prodUser) {
    const prodToken = await requestAdminToken(apiUrlProdFirebase, user.uid);
    await Promise.all(
      [
        !defaultUser && signInWithCustomToken(getAuth(), prodToken),
        !prodUser && signInWithCustomToken(authProd, prodToken),
      ].filter(Boolean),
    );
  }

  if (!devUser) {
    syncDevAuth(user.uid).catch(() => {});
  }

  return user;
};

function LogInComponent(props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorText, setErrorText] = useState("");

  useEffect(prewarmAdminApi, []);

  const onUsernameFormSubmit = (event) => {
    event.preventDefault();
    const email = username.toString().toLowerCase();
    props.setLoading(true);
    setErrorText("");
    signInWithPassword(email, password);
  };

  const signInWithPassword = (email, password) => {
    if (!email || !password) return;
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        validateAdmin(userCredential.user);
      })
      .catch((error) => {
        const errorMessage = error.message;
        let errorToShow = "Sorry something went wrong";
        if (errorMessage.includes("user-not-found")) {
          errorToShow = "Sorry we could not find an account for this username";
        }
        if (errorMessage.includes("wrong-password")) {
          errorToShow = "Incorrect Password";
        }
        props.setLoading(false);
        setErrorText(errorToShow);
      });
  };

  const validateAdmin = (user) => {
    signInToProjectAuths(user.uid)
      .then(() => {
        onSignInDone(user);
      })
      .catch((error) => {
        console.error(error);
        props.setLoading(false);
        setErrorText("Sorry, you are not authorized to access this portal.");
      });
  };

  const onSignInDone = (user) => {
    // Set auth cookie for 1 day persistence
    setAuthCookie(user.email);
    // Open the main dashboard
    props.setLoginSatisfied(true);
    // Loading state will be cleared when dashboard is ready
    // getAdminMetrics(user)
  };

  return (
    <div className="SignUpMethodContainer">
      <div>
        <h2>Addy AI Admin Login</h2>
      </div>
      <div>
        <form className="SignUpForm" onSubmit={onUsernameFormSubmit}>
          <input
            className="InputSignUp"
            autoComplete="off"
            autoCapitalize="off"
            placeholder="Username"
            onChange={(e) => setUsername(e.target.value)}
            value={username}
            type="text"
            name="name"
          />

          <input
            className="InputSignUp"
            autoComplete="off"
            autoCapitalize="off"
            placeholder="Password"
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            type="password"
            name="password"
          />

          <div className="SignUpErrorTextContainer">
            <p className="ReviewErrorText">{errorText}</p>
            {/* {this.state.errors} */}
          </div>

          <button
            className="SignUpFormSubmitButton"
            type="submit"
            disabled={props.isLoading}
          >
            {props.isLoading ? (
              <div className="loader-container">
                <div className="loader"></div>
                <p className="SignInButtonText">Logging in...</p>
              </div>
            ) : (
              <p className="SignInButtonText">Log in</p>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

function App() {
  const [loginSatisfied, setLoginSatisfied] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Start with loading to check cookie
  const [checkingAuth, setCheckingAuth] = useState(true);

  // Check for existing auth cookie on mount
  useEffect(() => {
    if (!isAuthCookieValid()) {
      setCheckingAuth(false);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    restoreProjectAuths()
      .then((user) => {
        if (cancelled) return;

        if (!user) {
          clearAuthCookie();
          setLoginSatisfied(false);
          return;
        }

        setLoginSatisfied(true);
      })
      .catch((error) => {
        if (cancelled) return;
        console.error("Failed to restore Firebase auth sessions:", error);
        clearAuthCookie();
        setLoginSatisfied(false);
      })
      .finally(() => {
        if (cancelled) return;
        setCheckingAuth(false);
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleLoginSuccess = () => {
    setLoginSatisfied(true);
    setIsLoading(false);
  };

  const handleLogout = () => {
    clearAuthCookie();
    setLoginSatisfied(false);
    // Sign out from Firebase as well
    const auth = getAuth();
    Promise.allSettled([auth.signOut(), authProd.signOut(), authDev.signOut()]);
  };

  // Show loading while checking auth cookie
  if (checkingAuth) {
    return (
      <div className="App">
        <div className="LoginContainer">
          <div className="loader-container">
            <div className="loader"></div>
            <p>Checking authentication...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {loginSatisfied ? (
        <Router>
          <Sidebar onLogout={handleLogout} />
          <Switch>
            <Route exact path="/">
              <HomeCatalogPage />
            </Route>
            <Route path="/dashboard">
              <DashboardPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/briefings">
              <NotionBriefingsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/marketing">
              <MarketingPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/arive">
              <Arive onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/settings">
              <WhitelistManagementPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/contacts">
              <ContactsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/user-permissions">
              <UserPermissionsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/loa-permissions">
              <LoaPermissionsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/demo-links">
              <DemoLinksPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/announcements">
                <AnnouncementsPage onReady={() => setIsLoading(false)} />
            </Route>

            <Route path="/notifications">
              <NotificationsPage onReady={() => setIsLoading(false)} />
            </Route>

            <Route path="/queue">
              <QueuePage onReady={() => setIsLoading(false)} />
            </Route>

            <Route path="/processing-monitoring">
              <ProcessingMonitoringPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/feedback">
              <FeedbackPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/prompts">
              <PromptsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/custom-instructions">
              <CustomInstructionsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/lead-conversion">
              <LeadConversionPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/qa-sprint-analytics">
              <QASprintAnalyticsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/global-search">
              <GlobalSearchPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/organization-loan-search">
              <OrganizationLoanSearchPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/pc-watchdog">
              <PCWatchdogPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/pc-performance">
              <PcPerformancePage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/enterprise-orgs">
              <EnterpriseOrgsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/org-users-report">
              <OrgUsersReportPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/signups">
              <SignupsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/ask-addy-chats">
              <AskAddyChatsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/changelogs/:id?">
              <ChangelogsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/dev-tools">
              <DevToolsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/prod-deployment">
              <ProdDeploymentPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/roadmap">
              <RoadmapPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/evals">
              <EvalsPage />
            </Route>
            <Route path="/langfuse-analytics">
              <LangfuseAnalyticsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/organization-limits">
              <OrganizationLimitsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/gcp-monitoring">
              <GcpMonitoringPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/cost-overview">
              <CostOverviewPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/loan-stage-analytics">
              <LoanStageAnalyticsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/support-insights">
              <SupportInsightsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/enterprise-billing-usage/:organizationId">
              <EnterpriseBillingUsageDetailPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/enterprise-billing-usage">
              <EnterpriseBillingUsagePage onReady={() => setIsLoading(false)} />
            </Route>
            <Route
              exact
              path="/org-usage-analytics/:organizationId/users/:userId"
            >
              <UserUsageProfilePage />
            </Route>
            <Route path="/org-usage-analytics/:organizationId">
              <OrgUsageDetailPage />
            </Route>
            <Route exact path="/org-usage-analytics">
              <OrgUsageIndexPage />
            </Route>
            <Route path="/client-tracking">
              <ClientTrackingPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/pilots">
              <PilotsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/demo-invites">
              <DemoInvitesPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/demo-access">
              <DemoAccessPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/integrations">
              <IntegrationsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/income-calculation-runs/:jobId">
              <IncomeCalculationRunDetailPage
                onReady={() => setIsLoading(false)}
              />
            </Route>
            <Route exact path="/income-calculation-runs">
              <IncomeCalculationRunsPage onReady={() => setIsLoading(false)} />
            </Route>
            {/* The detail route is declared first: `:recordId` would otherwise
                match nothing here, but keeping the pair ordered mirrors the
                Income Runs routes above and survives a later `exact` removal. */}
            <Route exact path="/newfi-split-edocs/:recordId">
              <NewfiSplitEdocDetailPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/newfi-split-edocs">
              <NewfiSplitEdocsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/project-views/:viewId">
              <ProjectViewPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/project-views">
              <ProjectViewsPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/model-switch-eval/:runId">
              <ModelSwitchEvalPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/model-switch-eval">
              <ModelSwitchEvalPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/org-overview/:organizationId">
              <OrgOverviewPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/org-overview">
              <OrgOverviewPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/referral-eligibility">
              <ReferralEligibilityPage onReady={() => setIsLoading(false)} />
            </Route>
            <Route exact path="/voice-console/voice-library">
              <VoiceConsolePage path="/library" onReady={() => setIsLoading(false)} />
            </Route>
            <Route path="/voice-console">
              <VoiceConsolePage onReady={() => setIsLoading(false)} />
            </Route>
          </Switch>
        </Router>
      ) : (
        <div className="LoginContainer">
          <LogInComponent
            setLoginSatisfied={handleLoginSuccess}
            setLoading={setIsLoading}
            isLoading={isLoading}
          />
        </div>
      )}
    </div>
  );
}

export default App;
